import {AfterViewInit, ChangeDetectorRef, Component, Optional} from "@angular/core";
import {LocalisableEntityData, provideEntityModel, provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {CustomReportModel} from "./custom-report.model";
import {ActivatedRoute, Params} from "@angular/router";
import {CustomReportConfigEntityModel} from "../custom-report-config/custom-report-config-entity.model";
import {FUISpinnersService, FUIStackedPageContextService} from "@fedeltapointofsale/ui";
import {CustomReportConfigData} from "../custom-report-config/custom-report-config.data";

@Component({
    selector: "wbo-custom-report",
    templateUrl: "./custom-report.component.html",
    providers: [
        provideEntityModel(CustomReportConfigEntityModel),
        provideReportModel(CustomReportModel)
    ]
})
export class CustomReportComponent extends AbstractReportPage implements AfterViewInit {
    reportConfig: CustomReportConfigData;

    constructor(public reportConfigModel: CustomReportConfigEntityModel,
                public model: CustomReportModel,
                @Optional() private stackedPageContextService: FUIStackedPageContextService,
                private changeDetectorRef: ChangeDetectorRef,
                private spinnerService: FUISpinnersService,
                private route: ActivatedRoute) {
        super();
    }

    ngAfterViewInit(): void {
        if (!this.stackedPageContextService) {
            this.route.params.subscribe((params: Params) => {
                this.loadReportConfig(params["reportId"], true);
            });
        }
    }

    loadReportConfig(reportId: string, loadDefault: boolean): void {
        this.spinnerService.open(true);
        this.reportConfigModel.loadEntity(reportId).then(() => {
            this.reportConfig = this.reportConfigModel.data;
            this.model.reportConfig = this.reportConfig;
            this.model.data.reportId = this.reportConfig.id;
            if (this.model.isEntityLocalisable()) {
                (<LocalisableEntityData<any>>this.model.data).localisableContext.universal = true;
            }
            if (loadDefault) {
                this.reportPageComponent.loadDefaultSavedReport();
            }
            this.spinnerService.close();
            this.changeDetectorRef.detectChanges();
        }).catch(error => {
            this.spinnerService.close();
            throw error;
        });
    }

    loadedSavedReport(): void {
        if (this.stackedPageContextService) {
            this.loadReportConfig(this.model.data.reportId, false);
        }
    }

    get myReportPostFix(): string {
        return this.reportConfigModel.data.id;
    }
}
